import { useDispatch } from "react-redux";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import HeaderUsersModule from "../components/HeaderUsersModule";
import { RiShareBoxFill } from "react-icons/ri";
import { Checkbox } from "../../SharedModule/components/Checkbox";
import { useState, useEffect } from "react";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  USERS_ALL_ROLES,
  ROUTE_USERS,
} from "../../SharedModule/utils/constants";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { useNavigate, useParams } from "react-router";
import {
  setActiveTab,
  setEntryReminder,
} from "../../SharedModule/redux/reducers/uiShared.reducer";
import {
  resetFiltersUsers,
  setActualUserSettings,
} from "../redux/reducers/usersList.reducer";
import { dateFormatEntryEdit } from "../../SharedModule/utils/formatters";
import { UsersService } from "../services/users";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { updateEntryReminder } from "../../TimesModule/redux/reducers/metaTimes.reducer";
import { useUserProfile } from "../hooks/useUserProfile";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const UserProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userId } = useParams();
  if (!userId) {
    navigate(ROUTE_USERS);
  }

  const {
    userRolesList,
    rolesLoaded,
    activeUserEmail,
    userAdminOrSuperAdmin,
    actualUser,
    isLoadingUserProfile,
  } = useUserProfile(Number(userId));

  const [efficiencyBonusChecked, setEfficiencyBonusChecked] = useState(
    actualUser?.userProfile ? actualUser?.userProfile.efficiencyBonus : false
  );
  const [timeEntryReminderChecked, setTimeEntryReminderChecked] = useState(
    actualUser?.userProfile ? actualUser?.userProfile.entryReminder : false
  );

  useEffect(() => {
    if (actualUser?.userProfile) {
      setEfficiencyBonusChecked(actualUser.userProfile.efficiencyBonus);
      setTimeEntryReminderChecked(actualUser.userProfile.entryReminder);
    }
  }, [actualUser]);

  useEffect(() => {
    document.title = "The Hub - User Profile";

    dispatch(setActiveTab(ROUTE_USERS));

    return () => {
      resetScrollY(globalThis.location.pathname);
      if (!globalThis.location.pathname.startsWith(ROUTE_USERS))
        dispatch(resetFiltersUsers());
    };
  }, []);

  const saveSettings = async () => {
    await UsersService.updateUserSettings(actualUser.id, {
      efficiencyBonus: efficiencyBonusChecked,
      entryReminder: timeEntryReminderChecked,
    })
      .then((response) => {
        dispatch(addToast({ mode: "success", message: response.message }));
        dispatch(
          setActualUserSettings({
            efficiencyBonus: efficiencyBonusChecked,
            entryReminder: timeEntryReminderChecked,
            email: actualUser?.email,
          })
        );
        // ASUITE11-3988: actual logged user changes his entryReminder
        if (activeUserEmail === actualUser?.email) {
          dispatch(setEntryReminder(timeEntryReminderChecked));
        }
        dispatch(
          updateEntryReminder({
            entryReminder: timeEntryReminderChecked,
            email: actualUser?.email,
          })
        );
      })
      .catch((error) => {
        dispatch(addToast({ mode: "error", message: error.data.error }));
      });
  };

  const goToEditProfile = () => {
    if (actualUser?.bambooId) {
      const newWindow = window.open(
        process.env.REACT_APP_USER_BAMBOO_LINK + actualUser?.bambooId,
        "_blank"
      );
      if (newWindow) {
        newWindow.focus();
      }
    } else {
      dispatch(
        addToast({
          mode: "error",
          message: "Bamboo ID is not set for " + actualUser?.fullName,
        })
      );
    }
  };

  return (
    <div className="content">
      <HeaderUsersModule
        actualUser={actualUser}
        isLoadingUserProfile={isLoadingUserProfile}
      />
      {(!rolesLoaded || isLoadingUserProfile) && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}

      {rolesLoaded &&
        !isLoadingUserProfile &&
        !verifyModuleAccess(true, USERS_ALL_ROLES, userRolesList) && (
          <ForbiddenPage />
        )}

      {rolesLoaded &&
        !isLoadingUserProfile &&
        verifyModuleAccess(true, USERS_ALL_ROLES, userRolesList) && (
          <>
            <form className="card entry-hour-box-background px-4 py-2 my-3">
              <div
                className="d-flex justify-content-between"
                style={{ margin: "1% 8%" }}
              >
                <h3 style={{ marginTop: "0.5rem" }}>Personal Information</h3>
                {userAdminOrSuperAdmin && (
                  <button
                    className="btn button-secondary"
                    type="button"
                    onClick={() => goToEditProfile()}
                  >
                    Edit Profile <RiShareBoxFill />
                  </button>
                )}
              </div>

              <div className="row" style={{ margin: "0 8%" }}>
                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Job Title{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.jobTitle}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Email Address{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.email}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Country{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.country}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Location{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.location}
                        disabled={true}
                      />
                    </label>
                    {actualUser?.userProfile && (
                      <span className="helper-title">
                        Effective Date{" "}
                        {actualUser?.userProfile
                          ? dateFormatEntryEdit(
                              actualUser?.userProfile.effectiveDateLocation
                            )
                          : ""}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="d-flex justify-content-between"
                style={{ margin: "1% 8%" }}
              >
                <h3>Employment Information</h3>
              </div>

              <div className="row" style={{ margin: "0 8%" }}>
                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Employment Status{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.employmentStatus}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Regular Hours per day{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.regularHoursPerDay}
                        disabled={true}
                      />
                    </label>
                    {actualUser?.userProfile
                      ?.effectiveDateRegularHoursPerDay && (
                      <span className="helper-title">
                        Effective Date{" "}
                        {actualUser?.userProfile
                          ? dateFormatEntryEdit(
                              actualUser?.userProfile
                                ?.effectiveDateRegularHoursPerDay
                            )
                          : ""}
                      </span>
                    )}
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Cost Center{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={
                          actualUser?.costCenter
                            ? actualUser?.costCenter?.number +
                              " - " +
                              actualUser?.costCenter?.name +
                              (!actualUser?.costCenter?.isActive ? " (X)" : "")
                            : ""
                        }
                        disabled={true}
                      />
                    </label>
                    {actualUser?.userProfile && (
                      <span className="helper-title">
                        Effective Date{" "}
                        {actualUser?.userProfile
                          ? dateFormatEntryEdit(
                              actualUser?.userProfile.effectiveDateCostCenter
                            )
                          : ""}
                      </span>
                    )}
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Supervisor{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.supervisorName}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Price Level{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={actualUser?.userProfile?.priceLevel}
                        disabled={true}
                      />
                    </label>
                    {actualUser?.userProfile?.priceLevelEffectiveDate && (
                      <span className="helper-title">
                        Effective Date{" "}
                        {actualUser?.userProfile?.priceLevelEffectiveDate
                          ? dateFormatEntryEdit(
                              actualUser?.userProfile?.priceLevelEffectiveDate
                            )
                          : ""}
                      </span>
                    )}
                  </div>
                  <div className="flex-column w-50 ms-5"></div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Hire Date{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={
                          actualUser?.userProfile
                            ? dateFormatEntryEdit(
                                actualUser?.userProfile.hireDate
                              )
                            : ""
                        }
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Terminated Date{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={
                          actualUser?.userProfile?.terminatedDate
                            ? dateFormatEntryEdit(
                                actualUser?.userProfile.terminatedDate
                              )
                            : ""
                        }
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <hr className="my-3" />
              </div>

              <div
                className="d-flex justify-content-between"
                style={{ margin: "1% 8%" }}
              >
                <h3>Settings</h3>
              </div>

              <div className="row" style={{ margin: "1% 8%" }}>
                <div className="d-flex p-0 mb-3">
                  <Checkbox
                    className="mt-2 me-5"
                    label="Efficiency Bonus"
                    value={efficiencyBonusChecked}
                    onClickHandler={() =>
                      setEfficiencyBonusChecked(!efficiencyBonusChecked)
                    }
                    isDisabled={!userAdminOrSuperAdmin}
                  />
                  <Checkbox
                    className="mt-2 mx-5"
                    label="Time Entry Reminder"
                    value={timeEntryReminderChecked}
                    onClickHandler={() =>
                      setTimeEntryReminderChecked(!timeEntryReminderChecked)
                    }
                    isDisabled={!userAdminOrSuperAdmin}
                  />
                  <button
                    className="btn btn-primary ms-5"
                    type="button"
                    disabled={!userAdminOrSuperAdmin}
                    onClick={() => saveSettings()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
      <Footer />
    </div>
  );
};
